/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'page': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.33 1c-1.68 0-3.29.66-4.48 1.84A6.24 6.24 0 0 0 5 7.27v33.46c0 1.66.67 3.26 1.85 4.43A6.36 6.36 0 0 0 11.33 47h25.34c1.68 0 3.29-.66 4.48-1.84A6.24 6.24 0 0 0 43 40.73v-23c0-.56-.22-1.09-.62-1.48v-.01l-13.97-14a4.24 4.24 0 0 0-3-1.24H11.32zM24 5.18v12.55c0 1.15.95 2.09 2.11 2.09h12.67v20.9a2.12 2.12 0 0 1-2.11 2.1H11.33a2.08 2.08 0 0 1-2.11-2.1V7.28a2.12 2.12 0 0 1 2.11-2.1L24 5.2zm11.8 10.46h-7.58v-7.5l7.57 7.5z"/>'
  }
})
